<template>
    <div style="padding: 20px;">
        <header>
            <!-- <el-select v-model="selectVal" placeholder="请选择" @change="changeDay">
                <el-option label="最近7天" value="7"></el-option>
                <el-option label="最近5天" value="5"></el-option>
                <el-option label="最近3天" value="3"></el-option>
            </el-select> -->
            <div class="downloadTotal"><h6>用户下载总数：</h6><h6>{{downloadTotal}}</h6></div>
            <div class="downloadTotal"><h6>本月下载量：</h6><h6>{{downloadTotalByThisMonth}}</h6></div>
            <div class="downloadTotal"><h6>上月下载量：</h6><h6>{{downloadTotalByLastMonth}}</h6></div>
            <div class="downloadTotal"><h6>用户注册总数：</h6><h6>{{userTotal}}</h6></div>
            <div class="downloadTotal"><h6>本月注册量：</h6><h6>{{userTotalByThisMonth}}</h6></div>
            <div class="downloadTotal"><h6>上月注册量：</h6><h6>{{userTotalByLastMonth}}</h6></div>
            <div class="downloadTotal"><h6>签到总数：</h6><h6>{{SignTimeTotal}}</h6></div>
            <div class="downloadTotal"><h6>上月签到总数：</h6><h6>{{SignTimeTotalByLastMonth}}</h6></div>
            <div class="downloadTotal"><h6>本月签到总数：</h6><h6>{{SignTimeTotalByThisMonth}}</h6></div>

        </header>
        <!-- <div id="main" class="main" style="width: 800px;height: 600px;">
            <div id="openAPP" style="width: 800px;height: 400px;"></div>
            <div id="queryIccid" style="width: 800px;height: 400px;"></div>
            <div id="register" style="width: 800px;height: 400px;"></div>
            <div id="userDownloadByTime" style="width: 800px;height: 400px;"></div>
            <div id="top" style="width: 825px;height: 400px;"></div>
        </div> -->
        <el-form :inline="true" style="margin-top:20px;padding-left:18px">
            <el-form-item>
                <el-button type="primary" @click="refresh">刷新数据</el-button>
            </el-form-item>
        </el-form>
        <div class="main">
            <div id="linechart" class="linechart" style="width: 800px;height: 600px;margin-top: 20px"></div>
            <div id="linechart2" class="linechart2" style="width: 800px;height: 600px;margin-top: 20px"></div>
        </div>
        <div class="main">
            <div id="linechart3" class="linechart3" style="width: 800px;height: 600px;margin-top: 20px"></div>
            <!-- <div id="rankingList" class="rankingList" style="width: 800px;height: 600px;margin-top: 20px;">
                <div class="rankingList">
                    <div class="rank_wrap">
                        <div class="header">
                            <h2>积分排行榜</h2>
                        </div>
                        <div class="rankListshow">
                            <ul>
                                <li>
                                    <div class="content">
                                        <div class="rank"><i font-size="18px" class="el-icon-medal-1"></i></div>
                                        <div class="username">沙漏倒不回~</div>
                                        <div class="signinNum">5208</div>
                                    </div>   
                                </li>
                                <li>
                                    <div class="content">
                                        <div class="rank"><i font-size="18px" class="el-icon-medal-1"></i></div>
                                        <div class="username">沙漏倒不回~</div>
                                        <div class="signinNum">5208</div>
                                    </div> 
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
        
        
    </div>
</template>

<script>
import request from '@/utils/request.js'
import * as echarts from 'echarts';
export default {
    // data(){
    //     return {
    //         selectVal: '7',
    //         downloadTotal: 0,
    //         downloadTotalByLastMonth: 0,
    //         downloadTotalByThisMonth: 0,
    //         userTotal: 0,
    //         userTotalByLastMonth: 0,
    //         userTotalByThisMonth: 0,
    //         userTotal: 0,
    //         openAPP: [],
    //         queryIccid: [],
    //         register: [],
    //         userDownloadByTime: [],
    //         time: [],
    //         top: []
    //     }
    // },
    // methods: {
    //     getAppCount(data){
    //         request({
    //             url: 'xxtx/app/count',
    //             method: 'get',
    //             params: data,
    //             headers: {
    //                 appid: '1'
    //             }
    //         }).then(res => {
    //             let result;
    //             if(res.data.code == 200){
    //                 this.time = [];
    //                 this.openAPP = [];
    //                 this.queryIccid = [];
    //                 this.register = [];
    //                 this.userDownloadByTime = [];
    //                 this.top = [];
    //                 result = res.data.data;
    //                 this.downloadTotal = result.total.downloadTotal;
    //                 this.downloadTotalByLastMonth = result.total.downloadTotalByLastMonth;
    //                 this.downloadTotalByThisMonth = result.total.downloadTotalByThisMonth;
    //                 this.userTotal = result.total.userTotal;
    //                 this.userTotalByLastMonth = result.total.userTotalByLastMonth;
    //                 this.userTotalByThisMonth = result.total.userTotalByThisMonth;
    //                 for(let key in result.week.openAPP){
    //                     this.time.push(key);
    //                     this.openAPP.push(result.openAPP[key]);
    //                 }
    //                 console.log(this.time)
    //                 for(let key in result.queryIccid){
    //                     this.queryIccid.push(result.queryIccid[key])
    //                 }
    //                 for(let key in result.register){
    //                     this.register.push(result.register[key])
    //                 }
    //                 for(let key in result.userDownloadByTime){
    //                     this.userDownloadByTime.push(result.userDownloadByTime[key])
    //                 }
    //                 let top1 = [];
    //                 let top2 = [];
    //                 result.TOP5.map(item => {
    //                     top1.push(item.phone);
    //                     top2.push(item.total);
    //                 })
    //                 this.top.push(top1, top2);
    //             }
    //             this.draw('openAPP', this.time, this.openAPP, '打开APP量', 'line');
    //             this.draw('queryIccid', this.time, this.queryIccid, '查询卡号量', 'line');
    //             this.draw('register', this.time, this.register, '用户注册量', 'line');
    //             this.draw('userDownloadByTime', this.time, this.userDownloadByTime, '用户下载量', 'line');
    //             this.draw('top', this.top[0], this.top[1], 'top5数据', 'bar');
    //         })
    //     },
    //     /**
    //      * id：dom元素id
    //      * xArr：横坐标的数据
    //      * yArr：纵坐标的数据
    //      * tit：标题
    //      * type：图的类型
    //      */
    //     draw(id, xArr, yArr, tit, type){
    //         let myChart = echarts.init(document.getElementById(id));
    //         let option = {
    //             title: {
    //                 text: tit + '统计图',
    //                 left: 'center'
    //             },
    //             tooltip: {
    //                 trigger: 'axis'
    //             },
    //             xAxis: {
    //                 type: 'category',
    //                 axisLabel: {
    //                     fontSize: 12 //默认为12
    //                 },
    //                 data: xArr
    //             },
    //             yAxis: {
    //                 type: 'value',
    //                 minInterval: 1 //坐标上不出现小数
    //             },
    //             series: [{
    //                 name: tit,
    //                 type,
    //                 data: yArr
    //             }]
    //         };
    //         myChart.setOption(option);
    //     }, 
    //     changeDay(val){
    //         this.getAppCount({day: val});
    //     }
    // },
    // created(){
    //     this.getAppCount({day: this.selectVal});
    // }


    data() {
        return {
            selectVal: '7',
            downloadTotal: 0,
            downloadTotalByLastMonth: 0,
            downloadTotalByThisMonth: 0,
            userTotal: 0,
            userTotalByLastMonth: 0,
            userTotalByThisMonth: 0,
            SignTimeTotal: 0,
            SignTimeTotalByLastMonth: 0,
            SignTimeTotalByThisMonth: 0,

            time: [],
            download: [],
            game: [],
            gameInfo: [],
            movie: [],
            openAPP: [],
            queryIccid: [],
            register: [],
            shop: []
        }
    },
    methods: {
        refresh() {
            this.time = [];
            this.game = [];
            this.download = [];
            this.gameInfo = [];
            this.movie = [];
            this.openAPP = [];
            this.queryIccid = [];
            this.register = [];
            this.shop = []
            this.getAppCount({day: this.selectVal});
        },
        getAppCount(data) {
            request({
                url: 'xxtx/app/count',
                methods: 'get',
                params: data,
                headers: {
                    appid: '1'
                }
            }).then (res => {
                if (res.data.code == 200) {
                    let result;
                    result = res.data.data;

                    // 总数量统计
                    this.downloadTotal = result.total.downloadTotal;
                    this.downloadTotalByLastMonth = result.total.downloadTotalByLastMonth;
                    this.downloadTotalByThisMonth = result.total.downloadTotalByThisMonth;
                    this.userTotal = result.total.userTotal;
                    this.userTotalByLastMonth = result.total.userTotalByLastMonth;
                    this.userTotalByThisMonth = result.total.userTotalByThisMonth;
                    this.SignTimeTotal = result.total.SignTimeTotal;
                    this.SignTimeTotalByLastMonth = result.total.SignTimeTotalByLastMonth;
                    this.SignTimeTotalByThisMonth = result.total.SignTimeTotalByThisMonth

                    // 统计图数据
                    for(let key in result.week.game) {
                        // 时间都是同一个时间,记录一次就行
                        this.time.push(key)
                        // game数组数据
                        this.game.push(result.week.game[key])
                    }
                    for(let key in result.week.download) {
                        this.download.push(result.week.download[key])
                    }
                    for(let key in result.week.gameInfo) {
                        this.gameInfo.push(result.week.gameInfo[key])
                    }
                    for(let key in result.week.movie) {
                        this.movie.push(result.week.movie[key])
                    }
                    for(let key in result.week.openAPP) {
                        this.openAPP.push(result.week.openAPP[key])
                    }
                    for (let key in result.week.queryIccid) {
                        this.queryIccid.push(result.week.queryIccid[key])
                    }
                    for (let key in result.week.register) {
                        this.register.push(result.week.register[key])
                    }
                    for (let key in result.week.shop) {
                        this.shop.push(result.week.shop[key])
                    }

                }
                else {
                    this.$message.error(res.data.result);
                }

                this.draw2(),
                this.draw3(),
                this.draw4()
            })
        },
        changeDay(val){
            this.getAppCount({day: val});
        },

        draw2() {
            let mychart2 = echarts.init(document.getElementById('linechart'));
            var colordata = ['#FFC501', '#EA6E29', '#05C985', '#1F8EFA', '#8086FB','00F5FF'];
            let option3 = {
                title: {
                    text: '功能数据统计图'
                },
                tooltip: {
                    trigger: 'axis'
                },
                toolbox: {
                    feature: {
                        dataView: {}
                    },
                    right:20
                },
                legend: {
                    type: 'plain', // 普通图例
                    color: colordata,
                    data: ['游戏点击量', '影视点击量',  '商品点击量', '查询量'],
                    right: '40px',
                    top: '5px',              
                },
                grid: {
                    top: 'middle',
                    left: '3%',
                    right: '4%',
                    bottom: '0%',
                    height: '80%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: this.time,
                    axisLine: {
                        lineStyle: {
                            color: "#999"
                        }
                    }
                },
                yAxis: {
                    type: 'value',

                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: '#DDD'
                        }
                    },
                    axisLine: {
                        show: false,
                        lineStyle: {
                            color: "#333"
                        },
                    },
                    nameTextStyle: {
                        color: "#999"
                    },
                    splitArea: {
                        show: false
                    }
                },
                series: [{
                        name: '游戏点击量',
                        type: 'line',
                        data: this.game,
                        color: "#F58080",
                        lineStyle: {
                            normal: {
                                width: 1.5,
                                color: {
                                    type: 'linear',

                                    colorStops: [{
                                        offset: 0,
                                        color: '#05C985' // 0% 处的颜色
                                    }, {
                                        offset: 0.4,
                                        color: '#05C985' // 100% 处的颜色
                                    }, {
                                        offset: 1,
                                        color: '#05C985' // 100% 处的颜色
                                    }],
                                    globalCoord: false // 缺省为 false
                                },
                                shadowColor: 'rgba(245,128,128, 0.5)',
                                shadowBlur: 5,
                                shadowOffsetY: 3
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: '#05C985',
                                borderWidth: 1,
                                /*shadowColor: 'rgba(72,216,191, 0.3)',
                                shadowBlur: 100,*/
                                borderColor: "#05C985"
                            }
                        },
                        smooth: true,
                        showSymbol: false
                    },
                    {
                        name: '影视点击量',
                        type: 'line',
                        data: this.movie,
                        lineStyle: {
                            normal: {
                                width: 1.5,
                                color: {
                                    type: 'linear',

                                    colorStops: [{
                                            offset: 0,
                                            color: '#1F8EFA' // 0% 处的颜色
                                        },
                                        {
                                            offset: 0.4,
                                            color: '#1F8EFA' // 100% 处的颜色
                                        }, {
                                            offset: 1,
                                            color: '#1F8EFA' // 100% 处的颜色
                                        }
                                    ],
                                    globalCoord: false // 缺省为 false
                                },
                                shadowColor: 'rgba(71,216,190, 0.5)',
                                shadowBlur: 5,
                                shadowOffsetY: 3
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: '#1F8EFA',
                                borderWidth: 1,
                                /*shadowColor: 'rgba(72,216,191, 0.3)',
                                shadowBlur: 100,*/
                                borderColor: "#1F8EFA"
                            }
                        },
                        smooth: true,
                        showSymbol: false
                    },
                    {
                        name: '商品点击量',
                        type: 'line',
                        data: this.shop,
                        lineStyle: {
                            normal: {
                                width: 1.5,
                                color: {
                                    type: 'linear',

                                    colorStops: [{
                                            offset: 0,
                                            color: colordata[4] // 0% 处的颜色
                                        },
                                        {
                                            offset: 0.4,
                                            color: colordata[4] // 100% 处的颜色
                                        }, {
                                            offset: 1,
                                            color: colordata[4] // 100% 处的颜色
                                        }
                                    ],
                                    globalCoord: false // 缺省为 false
                                },
                                shadowColor: 'rgba(249,165,137, 0.5)',
                                shadowBlur: 5,
                                shadowOffsetY: 3
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: colordata[4],
                                borderWidth: 1,
                                /*shadowColor: 'rgba(72,216,191, 0.3)',
                                shadowBlur: 100,*/
                                borderColor: "#FFAB4F"
                            }
                        },
                        smooth: true,
                        showSymbol: false
                    },
                    {
                        name: '查询量',
                        type: 'line',
                        data: this.queryIccid,
                        lineStyle: {
                            normal: {
                                width: 1.5,
                                color: {
                                    type: 'linear',

                                    colorStops: [{
                                            offset: 0,
                                            color: '#00ccff' // 0% 处的颜色
                                        },
                                        {
                                            offset: 0.4,
                                            color: '#00ccff' // 100% 处的颜色
                                        }, {
                                            offset: 1,
                                            color: '#00ccff' // 100% 处的颜色
                                        }
                                    ],
                                    globalCoord: false // 缺省为 false
                                },
                                shadowColor: 'rgba(85, 85, 85, 0.5)',
                                shadowBlur: 5,
                                shadowOffsetY: 3
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: "#00ccff",
                                borderWidth: 1,
                                /*shadowColor: 'rgba(72,216,191, 0.3)',
                                shadowBlur: 100,*/
                                borderColor: "#FFAB4F"
                            }
                        },
                        smooth: true,
                        showSymbol: false
                    }
                ]
            };
            mychart2.setOption(option3);
        },


        draw3() {
            let mychart3 = echarts.init(document.getElementById('linechart2'));
            var colordata = ['#FFC501', '#EA6E29', '#05C985', '#1F8EFA', '#8086FB','00F5FF'];
            let option2 = {
                title: {
                    text: '注册下载数据统计图'
                },
                tooltip: {
                    trigger: 'axis'
                },
                toolbox: {
                    feature: {
                        dataView: {}
                    },
                    right:20
                },
                legend: {
                    type: 'plain', // 普通图例
                    color: colordata,
                    data: ['每日下载', '每日注册',  '活跃'],
                    right: '40px',
                    top: '5px'
                },
                grid: {
                    top: 'middle',
                    left: '3%',
                    right: '4%',
                    bottom: '0%',
                    height: '80%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: this.time,
                    axisLine: {
                        lineStyle: {
                            color: "#999"
                        }
                    }
                },
                yAxis: {
                    type: 'value',

                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: '#DDD'
                        }
                    },
                    axisLine: {
                        show: false,
                        lineStyle: {
                            color: "#333"
                        },
                    },
                    nameTextStyle: {
                        color: "#999"
                    },
                    splitArea: {
                        show: false
                    }
                },
                series: [{
                        name: '每日下载',
                        type: 'line',
                        data: this.download,
                        color: "#F58080",
                        lineStyle: {
                            normal: {
                                width: 1.5,
                                color: {
                                    type: 'linear',

                                    colorStops: [{
                                        offset: 0,
                                        color: '#05C985' // 0% 处的颜色
                                    }, {
                                        offset: 0.4,
                                        color: '#05C985' // 100% 处的颜色
                                    }, {
                                        offset: 1,
                                        color: '#05C985' // 100% 处的颜色
                                    }],
                                    globalCoord: false // 缺省为 false
                                },
                                shadowColor: 'rgba(245,128,128, 0.5)',
                                shadowBlur: 5,
                                shadowOffsetY: 3
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: '#05C985',
                                borderWidth: 1,
                                /*shadowColor: 'rgba(72,216,191, 0.3)',
                                shadowBlur: 100,*/
                                borderColor: "#05C985"
                            }
                        },
                        smooth: true,
                        showSymbol: false
                    },
                    {
                        name: '每日注册',
                        type: 'line',
                        data: this.register,
                        lineStyle: {
                            normal: {
                                width: 1.5,
                                color: {
                                    type: 'linear',

                                    colorStops: [{
                                            offset: 0,
                                            color: '#1F8EFA' // 0% 处的颜色
                                        },
                                        {
                                            offset: 0.4,
                                            color: '#1F8EFA' // 100% 处的颜色
                                        }, {
                                            offset: 1,
                                            color: '#1F8EFA' // 100% 处的颜色
                                        }
                                    ],
                                    globalCoord: false // 缺省为 false
                                },
                                shadowColor: 'rgba(71,216,190, 0.5)',
                                shadowBlur: 5,
                                shadowOffsetY: 3
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: '#1F8EFA',
                                borderWidth: 1,
                                /*shadowColor: 'rgba(72,216,191, 0.3)',
                                shadowBlur: 100,*/
                                borderColor: "#1F8EFA"
                            }
                        },
                        smooth: true,
                        showSymbol: false
                    },
                    {
                        name: '活跃',
                        type: 'line',
                        data: this.openAPP,
                        lineStyle: {
                            normal: {
                                width: 1.5,
                                color: {
                                    type: 'linear',

                                    colorStops: [{
                                            offset: 0,
                                            color: '#ffcc66' // 0% 处的颜色
                                        },
                                        {
                                            offset: 0.4,
                                            color: '#ffcc66' // 100% 处的颜色
                                        }, {
                                            offset: 1,
                                            color: '#ffcc66' // 100% 处的颜色
                                        }
                                    ],
                                    globalCoord: false // 缺省为 false
                                },
                                shadowColor: 'rgba(255, 204, 102, 0.5)',
                                shadowBlur: 5,
                                shadowOffsetY: 3
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: '#ffcc66',
                                borderWidth: 1,
                                /*shadowColor: 'rgba(72,216,191, 0.3)',
                                shadowBlur: 100,*/
                                borderColor: "#1F8EFA"
                            }
                        },
                        smooth: true,
                        showSymbol: false
                    }
                
                ]
            };
            mychart3.setOption(option2);
        },

        draw4() {
            var fish = []
            var landlords = []
            var west = []
            for (let i = 0 ; i < this.gameInfo.length ; i++) {
                fish.push(this.gameInfo[i].fish)
                landlords.push(this.gameInfo[i].landlords)
                west.push(this.gameInfo[i].west)
            }
            let mychart4 = echarts.init(document.getElementById('linechart3'));
            var colordata = ['#FFC501', '#EA6E29', '#05C985', '#1F8EFA', '#8086FB','00F5FF'];
            let option4 = {
                title: {
                    text: '游戏数据统计图'
                },
                tooltip: {
                    trigger: 'axis'
                },
                toolbox: {
                    feature: {
                        dataView: {}
                    },
                    right:20
                },
                legend: {
                    type: 'plain', // 普通图例
                    color: colordata,
                    data: ['游戏点击量','捕鱼达人', '斗地主',  '西游'],
                    right: '40px',
                    top: '5px'
                },
                grid: {
                    top: 'middle',
                    left: '3%',
                    right: '4%',
                    bottom: '0%',
                    height: '80%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: this.time,
                    axisLine: {
                        lineStyle: {
                            color: "#999"
                        }
                    }
                },
                yAxis: {
                    type: 'value',

                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: '#DDD'
                        }
                    },
                    axisLine: {
                        show: false,
                        lineStyle: {
                            color: "#333"
                        },
                    },
                    nameTextStyle: {
                        color: "#999"
                    },
                    splitArea: {
                        show: false
                    }
                },
                series: [
                    {
                        name: '游戏点击量',
                        type: 'line',
                        data: this.game,
                        color: "#F58080",
                        lineStyle: {
                            normal: {
                                width: 1.5,
                                color: {
                                    type: 'linear',

                                    colorStops: [{
                                        offset: 0,
                                        color: '#05C985' // 0% 处的颜色
                                    }, {
                                        offset: 0.4,
                                        color: '#05C985' // 100% 处的颜色
                                    }, {
                                        offset: 1,
                                        color: '#05C985' // 100% 处的颜色
                                    }],
                                    globalCoord: false // 缺省为 false
                                },
                                shadowColor: 'rgba(5, 201, 133, 0.5)',
                                shadowBlur: 5,
                                shadowOffsetY: 3
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: '#05C985',
                                borderWidth: 1,
                                /*shadowColor: 'rgba(72,216,191, 0.3)',
                                shadowBlur: 100,*/
                                borderColor: "#05C985"
                            }
                        },
                        smooth: true,
                        showSymbol: false
                    },
                    {
                        name: '捕鱼达人',
                        type: 'line',
                        data: fish,
                        color: "#F58080",
                        lineStyle: {
                            normal: {
                                width: 1.5,
                                color: {
                                    type: 'linear',

                                    colorStops: [{
                                        offset: 0,
                                        color: '#CAE1FF' // 0% 处的颜色
                                    }, {
                                        offset: 0.4,
                                        color: '#CAE1FF' // 100% 处的颜色
                                    }, {
                                        offset: 1,
                                        color: '#CAE1FF' // 100% 处的颜色
                                    }],
                                    globalCoord: false // 缺省为 false
                                },
                                shadowColor: 'rgba(202, 225, 255, 0.5)',
                                shadowBlur: 5,
                                shadowOffsetY: 3
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: '#CAE1FF',
                                borderWidth: 1,
                                /*shadowColor: 'rgba(72,216,191, 0.3)',
                                shadowBlur: 100,*/
                                borderColor: "#05C985"
                            }
                        },
                        smooth: true,
                        showSymbol: false
                    },
                    {
                        name: '斗地主',
                        type: 'line',
                        data: landlords,
                        lineStyle: {
                            normal: {
                                width: 1.5,
                                color: {
                                    type: 'linear',

                                    colorStops: [{
                                            offset: 0,
                                            color: '#1F8EFA' // 0% 处的颜色
                                        },
                                        {
                                            offset: 0.4,
                                            color: '#1F8EFA' // 100% 处的颜色
                                        }, {
                                            offset: 1,
                                            color: '#1F8EFA' // 100% 处的颜色
                                        }
                                    ],
                                    globalCoord: false // 缺省为 false
                                },
                                shadowColor: 'rgba(71,216,190, 0.5)',
                                shadowBlur: 5,
                                shadowOffsetY: 3
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: '#1F8EFA',
                                borderWidth: 1,
                                /*shadowColor: 'rgba(72,216,191, 0.3)',
                                shadowBlur: 100,*/
                                borderColor: "#1F8EFA"
                            }
                        },
                        smooth: true,
                        showSymbol: false
                    },
                    {
                        name: '西游',
                        type: 'line',
                        data: west,
                        lineStyle: {
                            normal: {
                                width: 1.5,
                                color: {
                                    type: 'linear',

                                    colorStops: [{
                                            offset: 0,
                                            color: '#ffcc66' // 0% 处的颜色
                                        },
                                        {
                                            offset: 0.4,
                                            color: '#ffcc66' // 100% 处的颜色
                                        }, {
                                            offset: 1,
                                            color: '#ffcc66' // 100% 处的颜色
                                        }
                                    ],
                                    globalCoord: false // 缺省为 false
                                },
                                shadowColor: 'rgba(255, 204, 102, 0.5)',
                                shadowBlur: 5,
                                shadowOffsetY: 3
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: '#ffcc66',
                                borderWidth: 1,
                                /*shadowColor: 'rgba(72,216,191, 0.3)',
                                shadowBlur: 100,*/
                                borderColor: "#1F8EFA"
                            }
                        },
                        smooth: true,
                        showSymbol: false
                    }
                
                ]
            };
            mychart4.setOption(option4);


        }
    },
    created() {
        this.getAppCount({day: this.selectVal});
    }
}


</script>

<style lang="less" scoped>
header {
    text-align: center;
    line-height: 30px;
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 700;
    justify-content: space-between;
    overflow-x: hidden;
    min-width: 800px;
    .downloadTotal {
        flex: 1;
        height: 60px;
        border: 1px solid #efefef;
        margin-left: 20px;
        background-color: #f9f9f9;
        h6:last-child {
            font-weight: 700;
        }
    }
    .downloadTotal:hover {
        border: 1px solid #3490ee;
		background: #ddf4ff;
		transition: .5s;
    }
}
.main {
    margin-top: 50px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    .rankingList {
        width: 100%;
        height: 100%;
        .rank_wrap {
            padding: 20px 100px;
            .header {
                background: #3490ee;
                h2 {
                font-weight: 400;
                color: #ffffff;
                text-align: center;
                padding: 14px 0;
            }
            }
            .rankListshow {
                box-sizing: border-box;
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                align-items: center;
                background: rgba(0, 255, 255, 0.1);
                ul {
                    flex: 1;
                    li {
                        text-align: center;
                        height: 40px;
                        line-height: 40px;
                        box-sizing: border-box;
                        border: 1px solid orange;
                        border-top: none;
                        .rank, .username {
                            width: 33%;
                            float: left;
                            font-size: 28px;
                        }
                        .username {
                            font-size: 16px;
                        }
                    }
                    li:first-child {
                        color: orange;
                    }
                }
                
            }
        }
    }
}
</style>